import type {Department, DepartmentResponse, FinishedActionResponse, FinishedSaveResponse, Rec, RecordHolding, TypeOrIdentifiedStub} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import {transferify} from 'shared/utils/data-service-utils';

export class RecordHoldingDataService {
    public static readonly serviceName = 'recordHoldingDataService';
    public static readonly RECORD_HOLDINGS_ROUTE = 'record-holdings';
    public static readonly RECORD_HOLDINGS_ASSIGNABLE_DEPARTMENTS_ROUTE = 'record-holdings/assignable-departments';
    public static readonly RECORD_HOLDINGS_DELETE_ROUTE = 'record-holdings/delete';
    public static readonly RECORD_HOLDINGS_DISCARD_ROUTE = 'record-holdings/discard';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async queryRecordHoldings(params: {record: TypeOrIdentifiedStub<Rec>}): Promise<RecordHolding[]> {
        return this.ajaxService
            .createRequest(RecordHoldingDataService.RECORD_HOLDINGS_ROUTE)
            .get(transferify(params));
    }

    public async getAssignableDepartments(): Promise<DepartmentResponse[]> {
        return this.ajaxService
            .createRequest(RecordHoldingDataService.RECORD_HOLDINGS_ASSIGNABLE_DEPARTMENTS_ROUTE)
            .get();
    }

    public async createRecordHolding(record?: TypeOrIdentifiedStub<Rec>, department?: TypeOrIdentifiedStub<Department>): Promise<FinishedSaveResponse<RecordHolding>> {
        return this.ajaxService
            .createRequest(RecordHoldingDataService.RECORD_HOLDINGS_ROUTE)
            .post(transferify({department, record}));
    }

    public async deleteRecordHolding(recordHolding: RecordHolding): Promise<FinishedActionResponse> {
        return this.ajaxService
            .createRequest(RecordHoldingDataService.RECORD_HOLDINGS_DELETE_ROUTE)
            .post(transferify({recordHolding}));
    }

    public async discardRecordHolding(recordHolding: RecordHolding): Promise<FinishedActionResponse> {
        return this.ajaxService
            .createRequest(RecordHoldingDataService.RECORD_HOLDINGS_DISCARD_ROUTE)
            .post(transferify({recordHolding}));
    }
}